import { Button, Flex, Modal, Spin } from "antd"
import { forwardRef, useImperativeHandle, useState } from "react"
import './StopsModal.less'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"
import { useLocation } from "react-router-dom"
import { ExportOutlined, LoadingOutlined } from "@ant-design/icons"
import config from "../../../../config"
import AnalyticsHelper from "../../../../helpers/analytics"

const transportTypeHelper = (type) => {
    switch (type) {
        case 'kmb':
        case 'ctb':
            return 'Bus'
        case 'gmb':
            return 'Minibus'
        default:
            return 'Transportation'
    }
}

const StopsModal = forwardRef(({ open, handleClose }, ref) => {
    const [data, setData] = useState({ open: false })
    const [loading, setLoading] = useState(false)
    const location = useLocation()
    const pathname = location.pathname
    const showDestination = pathname.includes('/from-hkust/bus-stops')

    useImperativeHandle(ref, () => {
        return ({
            closeModal: () => setData({ open: false }),
            setData: (data) => {
                setData((state) => ({ ...state, open: true, stops: data }))
            },
            setInfo: (route, destination, provider) => setData(state => ({ ...state, route, destination, provider })),
            isLoading: (loading) => setLoading(loading),
            getStopsByRouteAndSequence: (callback) => callback()
        })
    }, [])

    return (
        <Modal onCancel={handleClose} destroyOnHidden open={data.open} title='Stops' footer={null} mask className="stops-modal">
            <div className="stops-body">
                {
                    loading ? <Spin indicator={<LoadingOutlined spin />} size="large" style={{ margin: 'auto', display: 'block' }} /> :
                        <>
                            <p className="title">
                                {transportTypeHelper(data?.provider)} - {data.route} {showDestination ? `(To - ${data?.destination || 'Destination'})` : null}
                            </p>

                            {
                                data?.stops && data.stops.length ?
                                    <Flex vertical gap={6}>
                                        {data.stops.map((item, i, arr) => {
                                            return <div key={i} {...(i === 0 && { 'data-current': true })} className="stop-card">
                                                <div>
                                                    {
                                                        i === 0 ?
                                                            <FontAwesomeIcon icon={faMapMarkerAlt} fontSize={22} />
                                                            : <FontAwesomeIcon icon={faArrowRight} fontSize={22} />
                                                    }
                                                </div>
                                                <div className="content">
                                                    <p>{item.name_en}</p>
                                                    <p>{i === 0 ? 'Current' : i === 1 ? 'Next Stop' : 'Following'}</p>
                                                </div>
                                                {item.lat != null && item.long != null && (
                                                    <Button
                                                        className="stop-map-link"
                                                        type="text"
                                                        size="large"
                                                        icon={<ExportOutlined style={{ fontSize: 22 }} />}
                                                        aria-label="Open in Google Maps"
                                                        onClick={() => AnalyticsHelper.track('open_stop_map', {
                                                            route: data.route,
                                                            provider: data.provider,
                                                            name: item.name_en,
                                                            stop_position: i
                                                        })}
                                                        href={`${config.googleMapsSearchUrl}${item.lat},${item.long}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    />
                                                )}
                                            </div>
                                        })}
                                    </Flex>
                                    : null
                            }
                        </>
                }
            </div>
        </Modal>
    )
})

export default StopsModal